import React, { useCallback } from 'react';
import { Checkbox } from '@vtblife/uikit';

import { NearbyOptions } from '@search/filter-enums/enums/NearbyOptions';

import { NearbySchoolFilter } from '../../../../models/Filter';

interface INearbySchoolButtonFilterView {
    filter: NearbySchoolFilter;
    handleChange: (filter: NearbySchoolFilter) => void;
}

export const NearbySchoolButtonFilterView: React.FC<INearbySchoolButtonFilterView> = ({
    filter,
    handleChange
}) => {
    const onChange = useCallback((newValue: boolean) => {
        if (newValue) {
            handleChange(new NearbySchoolFilter((NearbyOptions.GOOD_SCHOOL)));
        } else {
            handleChange(new NearbySchoolFilter());
        }
    }, [ handleChange ]);

    return (
        <div style={{ width: 'max-content' }}>
            <Checkbox
                name='nearbySchool'
                dataTest='nearbySchool'
                value={filter.hasNearbySchool === NearbyOptions.GOOD_SCHOOL}
                onChange={onChange}
                variant='filter'
                block
            >
                Хорошая школа
            </Checkbox>
        </div>
    );
};
